import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface ChecklistRow {
  readonly checklistId: string;
  readonly checklistCode: string;
  readonly checklistName: string;
  readonly complianceArea: string;
  readonly isMandatory: boolean;
}

export function M21ComplianceDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ChecklistRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ChecklistRow[] }>('/v1/compliance/checklists', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m21.compliance.loading')}</p>;
  return (
    <main aria-label="compliance-dashboard">
      <h1>{t('m21.compliance.title')}</h1>
      <table aria-label="compliance-checklists-table">
        <thead><tr><th>{t('m21.compliance.colCode')}</th><th>{t('m21.compliance.colName')}</th><th>{t('m21.compliance.colArea')}</th><th>{t('m21.compliance.colMandatory')}</th></tr></thead>
        <tbody>
          {rows.map((c) => (
            <tr key={c.checklistId}>
              <td>{c.checklistCode}</td>
              <td>{c.checklistName}</td>
              <td>{c.complianceArea}</td>
              <td>{c.isMandatory ? t('m21.compliance.yes') : t('m21.compliance.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
